export default "__VITE_ASSET__CgGU1TZM__"